<script>
import { defineComponent } from 'vue'
const name = 'PdfCartaPropostaComponente'

export default defineComponent({
  name,

  components: {},

  props: {
    componente: {
      type: Object,
      default: () => {}
    },

    index: {
      type: Number,
      default: 0
    },


  },

  mounted () {},

  updated () {},

  data () {
    return {}
  },

  methods: {},

  computed: {
    descricaoSistemaLabelValue () {
      if(this.componente.descricaoSistema === 0 ){
        return {
          label: "Descrição do Sistema",
          value: this.componente.sistema
        }
      }
      if(this.componente.descricaoSistema === 2 ){
        return {
          label: "Produto",
          value: this.componente.produtoSistema
        }
      }
      if(this.componente.descricaoSistema === 3 ){
        return {
          label: "Protótipo",
          value: this.componente.prototipoSistema
        }
      }
      if(this.componente.descricaoSistema === 4 ){
        return {
          label: "Conforme Planta",
          value: ""
        }
      }
      if(this.componente.descricaoSistema === 5 ){
        return {
          label: "Conforme Arquivo Digital",
          value: ""
        }
      }
      return {
          label: "",
          value: ""
        }
    },

    embalagemColetivaArray(){
      const embalagemArray = []
      if(this.componente.embalagemEspecificaFilmeEncolhivel){
        embalagemArray.push(`Filme Encolhível: ${this.componente.quantidadeFilmeEncolhivel}`)
      }
      if(this.componente.embalagemEspecificaCaixaColetiva){
        embalagemArray.push(`Filme Encolhível: ${this.componente.quantidadeCaixaColetiva}`)
      }
      if(this.componente.embalagemEspecificaPalete){
        embalagemArray.push(`Palete: ${this.componente.quantidadePalete}`)
      }
      if(this.componente.embalagemEspecificaPapelEmbrulho){
        embalagemArray.push(`Papel Embrulho: ${this.componente.quantidadePapelEmbrulho}`)
      }
      if(this.componente.quantidadeOutros ){
        embalagemArray.push(`Outros: ${this.componente.quantidadeOutros}`)
      }
  
      return embalagemArray
    }

  }
})
</script>

<template>
  <td >
    <figure class="title-container">
      <img src="@/assets/imgs/icone_componente_orcamento.svg" />

      <figcaption class="title">
        <h4>{{ `Componente ${index + 1}` }}</h4>
        <p>{{ componente.componenteTipoTexto }}</p>
      </figcaption>
    </figure>

    <div class="component-item-container">
      <div class="component-item">
        <em>Medidas</em>
        <p>
        {{ 
          (componente.numeroComprimento != 0) && (componente.numeroLargura != 0)   ? 
          componente.numeroComprimento + ' x ' + componente.numeroLargura + ' x ' + componente.numeroAltura + 
          ' x ' + componente.numeroAlturaTampa : componente.descricaoMedidasTexto
        }}
        </p>
      </div>
      <div class="component-item">
        <em>Descrição do Sistema</em>
        <p>{{ componente.sistema }}</p>
      </div>
      <div class="component-item">
        <em>Cor Frente</em>
        <p>{{ componente.quantidadeCoresFrente }} Cor(es)</p>
      </div>
      <div class="component-item">
        <em>Cor Verso</em>
        <p>{{ componente.quantidadeCoresVerso }} Cor(es)</p>
      </div>
      <div class="component-item">
        <em>Acabamento Frente</em>
        <p>{{ componente.descricaoAcabamentoFrenteTexto }}</p>
      </div>
      <div class="component-item">
        <em>Acabamento Verso</em>
        <p>{{ componente.descricaoAcabamentoVersoTexto }}</p>
      </div>
      <div class="component-item">
        <em>Material</em>
        <p>{{ componente.descricaoMaterialTexto }}</p>
      </div>
      <div class="component-item">
        <em>Onda</em>
        <p>{{ componente.descricaoOndaTexto }}</p>
      </div>
      <div class="component-item">
        <em>Capa Externa</em>
        <p>{{ componente.descricaoCapaExternaTexto }}</p>
      </div>
      <div class="component-item">
        <em>Capa Interna</em>
        <p>{{ componente.descricaoCapaInternaTexto }}</p>
      </div>
      <div class="component-item">
        <em>Papel de Onda</em>
        <p>{{ componente.descricaoPapelOndaTexto }}</p>
      </div>
      <div  class="component-item">
        <em>{{ descricaoSistemaLabelValue.label }}</em>
        <p>{{ descricaoSistemaLabelValue.value }}</p>
      </div> 
      <div class="component-item embalagem-coletiva-container">
        <em>Embalagem Coletiva</em>
        <p>
          <span 
            v-for="(item, index) in embalagemColetivaArray" :key="index">
            <span v-if="index > 0">, </span>
            <span>{{ item }}</span>
          </span>
        </p>
      </div>
    </div>
  
  </td>
</template>

<style scoped>
.embalagem-coletiva-container{
  grid-column : 1 / 3;
}

p,
h3,h4 {
  padding: 0;
  margin: 0;
  font-family: 'MontSerrat';
}

p,em{
  font-size: .7rem;
}

td {
  background-color: #f9f9f9;
  width: 325px;
  height: 430px;
  padding: 1rem !important;
  border-radius: 16px;
}

.title-container {
  padding: 0;
  margin: 0;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
}

.title-container img {
  width: 3rem;
  height: auto;
}
.title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.5rem;
}

.title h4{
  color:#4f2c19;
}

.component-item-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(1fr, auto-fill);
  column-gap: .5rem;
  row-gap: 1rem;
}

.component-item{
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 0.25rem;

}


.component-item em {
  font-style: normal;
  font-weight: bold;
  color: #3f3f3f;
  
}
.component-item p {
  color: #8a8a8a;
}
</style>
